import React, { useEffect } from "react";
import { tokens } from "../../theme";
import {
  useTheme,
  Box,
  IconButton,
  Typography,
  Avatar,
  Divider,
} from "@mui/material";
import NotificationsOutlinedIcon from "@mui/icons-material/NotificationsOutlined";
import Badge from "@mui/material/Badge";
import Button from "@mui/material/Button";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import LogoutIcon from "@mui/icons-material/Logout";
import { logoutApi } from "../../state/action/authAction";
import { useNavigate } from "react-router";
import Logo from "../../assets/Logo_Final.png";
import { useDispatch, useSelector } from "react-redux";
import { Notification } from "../../state/action/notification";

const Topbar = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const users = useSelector((store) => store?.auth?.user);

  const [anchorEl, setAnchorEl] = React.useState(null);
  const [anchorElNoti, setAnchorElNoti] = React.useState(null);
  const [notificationData, setNotificationData] = React.useState([]);
  const [count, setCount] = React.useState(0);
  const openNoti = Boolean(anchorElNoti);
  const open = Boolean(anchorEl);

  useEffect(() => {
    getAllNotification();
  }, []);

  useEffect(() => {
    window.OneSignal.push(function () {
      window.OneSignal.on("notificationDisplay", function () {
        getAllNotification();
      });
    });
  }, []);

  const getAllNotification = async () => {
    const res = await Notification();
    if (res?.status === true) {
      setNotificationData(res?.data);
      setCount(res?.data?.length);
    } else {
      setNotificationData([]);
    }
  };

  const handleClick = (event) => setAnchorEl(event.currentTarget);
  const handleClose = () => setAnchorEl(null);
  const handleClickNoti = (event) => setAnchorElNoti(event.currentTarget);
  const handleCloseNoti = () => setAnchorElNoti(null);

  const logoutAdmin = async () => {
    dispatch(logoutApi());
  };

  return (
    <Box
      display="flex"
      justifyContent="space-between"
      alignItems="center"
      px={2}
      py={0.7}
      sx={{
        backgroundColor: "#fff",
        boxShadow: "0 1px 4px rgba(0,0,0,0.08)",
        position: "sticky",
        top: 0,
        zIndex: 999,
      }}
    >
      <Box display="flex" alignItems="center" gap={1} sx={{ marginLeft: "auto" }}>
        <IconButton
          id="basic-button-noti"
          aria-controls={openNoti ? "notification" : undefined}
          aria-haspopup="true"
          aria-expanded={openNoti ? "true" : undefined}
          onClick={handleClickNoti}
          sx={{ color: colors.grey[500] }}
        >
          <Badge color="info" badgeContent={count}>
            <NotificationsOutlinedIcon sx={{ fontSize: "22px" }} />
          </Badge>
        </IconButton>

        <Button
          id="basic-button"
          aria-controls={open ? "basic-menu" : undefined}
          aria-haspopup="true"
          aria-expanded={open ? "true" : undefined}
          onClick={handleClick}
          sx={{ textTransform: "none", gap: 1 }}
        >
          <Typography
            sx={{ fontSize: "14px", color: "#000", fontWeight: 600 }}
          >
            {users?.fname + " " + users?.lname}
          </Typography>
          <Avatar
            src="/broken-image.jpg"
            alt="profile"
            sx={{ width: 36, height: 36, bgcolor: "#dedada", cursor: "pointer" }}
          />
        </Button>

        <Menu
          id="basic-menu"
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
          MenuListProps={{ "aria-labelledby": "basic-button" }}
          sx={{ "& .MuiPaper-root": { backgroundColor: "#fff" } }}
        >
          <MenuItem
            onClick={() => { handleClose(); navigate("/profilepage"); }}
            sx={{ color: "#000", fontSize: "14px" }}
          >
            <AccountCircleIcon sx={{ color: "rgb(107, 114, 128)", fontSize: "22px", mr: 1 }} />
            My Profile
          </MenuItem>
          <MenuItem
            onClick={() => logoutAdmin()}
            sx={{ color: "#000", fontSize: "14px" }}
          >
            <LogoutIcon sx={{ color: "rgb(107, 114, 128)", fontSize: "22px", mr: 1 }} />
            Logout
          </MenuItem>
        </Menu>
      </Box>

      <Menu
        id="notification"
        anchorEl={anchorElNoti}
        open={openNoti}
        onClose={handleCloseNoti}
        MenuListProps={{ "aria-labelledby": "basic-button-noti" }}
        sx={{
          "& .MuiPaper-root": { backgroundColor: "#fff", maxHeight: 320, width: 320 },
        }}
      >
        {notificationData.length === 0 && (
          <MenuItem sx={{ color: "#666", fontSize: "14px" }}>No notifications</MenuItem>
        )}
        {notificationData.map((item) => (
          <div key={item.id}>
            <MenuItem
              onClick={() => {
                handleCloseNoti();
                if (item.type === 0) navigate("/userDetail", { state: item.userId });
                if (item.type === 1) navigate("sellerOrder");
                if (item.type === 2) navigate("buyerOrder");
                if (item.type === 3) navigate("/product");
              }}
              sx={{ color: "#000", fontSize: "14px", alignItems: "flex-start", py: 1.5 }}
            >
              <Avatar src={Logo} sx={{ width: 30, height: 30, mr: 1.5, mt: 0.5 }} />
              <Box>
                <Typography variant="body2" fontWeight={600} color="black">
                  {item.title}
                </Typography>
                <Typography variant="caption" color="text.secondary">
                  {item.description}
                </Typography>
              </Box>
            </MenuItem>
            <Divider sx={{ bgcolor: "rgba(107, 114, 128, .2)" }} />
          </div>
        ))}
      </Menu>
    </Box>
  );
};

export default Topbar;
